// NPM
import React, { useState, useEffect, useMemo } from "react";
import _ from "lodash";

// State
import { useSelector } from "react-redux";

// Services
import embedService from "services/embedService";

// Constants
const rowsToShow = 10;

function RidingProjectionsTable(props) {
  const parties = useSelector((state) => state.parties.value);
  const [showingAll, setShowingAll] = useState(false);
  const campaignConfig = useSelector((state) => state.campaignConfig.value);

  useEffect(embedService.postHeight, [showingAll]);

  const supportsCurrent = useMemo(() => {
    return !!props.ridingProjections.find(
      (ridingProjection) => "current" in ridingProjection,
    );
  });

  const renderParty = (ridingProjectionIndex, partyId, bold = true) => {
    const party = parties.find((p) => p.id === partyId);

    return (
      <span
        key={`RidingProjectionsTable__row-${ridingProjectionIndex}-prediction-${partyId}`}
        className="RidingProjectionsTable__prediction"
        style={{ color: party?.color, fontWeight: bold ? "600" : "500" }}
      >
        {party?.short ?? partyId}
      </span>
    );
  };

  const renderRidingProjectionRow = (
    ridingProjection,
    ridingProjectionIndex,
  ) => {
    return (
      <tr
        key={`RidingProjectionsTable__row-${ridingProjectionIndex}`}
        className="RidingProjectionsTable__row"
      >
        <td>{ridingProjection.riding_name}</td>
        <td>
          {ridingProjection.prediction
            .split("/")
            .map((prediction) =>
              renderParty(ridingProjectionIndex, prediction),
            )}
        </td>
        <td>{ridingProjection.confidence}</td>

        {supportsCurrent && (
          <td>
            {renderParty(
              ridingProjectionIndex,
              ridingProjection.current,
              false,
            )}
          </td>
        )}
      </tr>
    );
  };

  if (_.isBlank(parties)) {
    return null;
  }

  const visibleRidingProjections = props.ridingProjections.slice(
    0,
    showingAll ? props.ridingProjections.length : rowsToShow,
  );
  const showAllText = _.get(
    campaignConfig,
    "sections.RidingProjections.showAllText",
  );
  const showLessText = _.get(
    campaignConfig,
    "sections.RidingProjections.showLessText",
  );
  const showButton =
    props.ridingProjections.length > visibleRidingProjections.length ||
    showingAll;

  return (
    <React.Fragment>
      <table className="Signal__section-visualization RidingProjectionsTable">
        <thead>
          <tr>
            <th>Riding Name</th>
            <th>Prediction</th>
            <th>Confidence</th>
            {supportsCurrent && <th>Current</th>}
          </tr>
        </thead>
        <tbody>{visibleRidingProjections.map(renderRidingProjectionRow)}</tbody>
      </table>
      <div className="ShowMore">
        {showButton && (
          <button
            className="button is-rounded"
            onClick={() => setShowingAll(!showingAll)}
          >
            {showingAll ? showLessText : showAllText}
          </button>
        )}
      </div>
    </React.Fragment>
  );
}

export default RidingProjectionsTable;
